import JsonTextKeys from '../../assets/texts.json'

export const TextKeys = JsonTextKeys

export const Texts = {
  startTeamVoiceCall: {
    texts: {
      en: 'Start Voice Call'
    }
  },
  connectWithTeammates: {
    texts: {
      en: 'Connect with your assigned teammates through voice. Note: Your teammates are not in a call currently.'
    }
  },
  startCall: {
    texts: {
      en: 'Start Call'
    }
  },
  emptyRoomTooltip: {
    texts: {
      en: "Your teammates are not in a call at the moment. Starting now creates an open session they can join. You'll be connected to an empty room until others arrive."
    }
  },
  joinTeamCallFirst: {
    texts: {
      en: 'Join Your Team Call First to Launch the Game'
    }
  },
  teamCallRequirement: {
    texts: {
      en: 'To ensure seamless communication during your gaming session, you must start or join a team call and grant microphone and sound permissions. This will activate the game client once confirmed.'
    }
  },
  startTeamCallAndJoin: {
    texts: {
      en: 'Start Team Call & Join Game →'
    }
  },
  teamCallTooltip: {
    texts: {
      en: 'Your team needs real-time audio to collaborate during practice. Starting this call ensures everyone is connected before gameplay begins.'
    }
  }
}
